import { FC } from 'react';
import { useCoresPainel } from '@/components/paineis/chartTheme';
import PainelShell from '@/components/paineis/PainelShell';
import PainelVendas from '@/components/paineis/vendas/PainelVendas';
import { usePainelFiltrado } from '@/hooks/usePainelFiltrado';
import { dashboardsService } from '@/services/dashboards.service';
import type { VendasPayload } from '@/types/dashboards';

const buscarVendas = (params: Record<string, string>) => dashboardsService.getEquiplexVendas(params);

/**
 * Forecast e vendas da Equiplex (`/paineis/equiplex/vendas`) — o "Forecast por SKU/UF"
 * do Manus com dado real: demanda do Balanceamento de Linha × nota fiscal, por mês, SKU e
 * UF de destino. Lê o último snapshot; nenhuma planilha entra no painel.
 */
const EquiplexVendasPage: FC = () => {
  const cores = useCoresPainel();
  const { estado, barra } = usePainelFiltrado<VendasPayload>(buscarVendas);
  return (
    <PainelShell
      estado={estado}
      prefixo="vendas"
      origem="vendas"
      titulo="Forecast e vendas"
      subtitulo="Forecast do comercial × faturado no mês de produção (16 a 15), por SKU e por UF de destino."
      corte={(p) => p.corte}
    >
      {({ id, payload }) => (
        <>
          {barra(payload.recorte)}
          <PainelVendas key={id} payload={payload} cores={cores} />
        </>
      )}
    </PainelShell>
  );
};

export default EquiplexVendasPage;
